import { FunctionalComponent } from 'preact';
import { useCallback } from 'preact/hooks';
import { Dialog, DialogBody, DialogFooter, DialogHeader, DialogManager } from '@accedo/ctv-ui-dialog';
import { Button as CtvButton } from '@accedo/ctv-ui-button';
import { DIALOG_TEXT } from '##/constants/text';

export const ErrorDialog: FunctionalComponent = () => {
  const onOk = useCallback((): void => {
    DialogManager.close('cancel');
  }, []);

  return (
    <Dialog id={'ErrorDialog'} onOpenFocusId="cancel">
      <DialogHeader alignment="center" headerText={DIALOG_TEXT.NETWORK_ERROR_TITLE} />
      <DialogBody alignment="center">{DIALOG_TEXT.NETWORK_ERROR_MESSAGE}</DialogBody>
      <DialogFooter alignment="end">
        <CtvButton id="ok" onSelect={onOk} size="large" buttonType="primary">
          {DIALOG_TEXT.OK_BUTTON}
        </CtvButton>
      </DialogFooter>
    </Dialog>
  );
};

export const ErrorDialogElement = <ErrorDialog />;
